<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <business-qualifications-header></business-qualifications-header>
        <business-qualifications-table></business-qualifications-table>
    </b-col>
</template>

<script>
    import BusinessQualificationsHeader from './business-qualifications/BusinessQualificationsHeader.vue'
    import BusinessQualificationsTable from './business-qualifications/BusinessQualificationsTable.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'

    export default {
        dependencies: ['careerLevel', 'popup'],
        components: { BusinessQualificationsHeader, BusinessQualificationsTable, FuturocoinsFromMining },
        beforeMount () {
            this.careerLevel.fetchData()
        }
    }
</script>

<style lang="scss" scoped>
    @media(min-width: 991px){
        .space{
            margin-bottom: 33px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/BusinessQualificationsContent.vue